export default function SearchSkeleton() {
  return (
    <div className="relative w-full">
      {/* Banner skeleton */}
      <div className="h-[300px] w-full animate-pulse rounded bg-gray-200" />

      {/* Search bar skeleton */}
      <div className="absolute -bottom-8 left-1/2 flex w-[90%] max-w-5xl -translate-x-1/2 transform items-center gap-4 rounded-xl bg-white px-6 py-4 shadow-lg">
        {/* Khách sạn */}
        <div className="flex-1">
          <div className="mb-2 h-4 w-24 animate-pulse rounded bg-gray-200" />
          <div className="h-5 w-40 animate-pulse rounded bg-gray-200" />
        </div>
        {/* Ngày nhận - trả */}
        <div className="flex-1">
          <div className="mb-2 h-4 w-32 animate-pulse rounded bg-gray-200" />
          <div className="h-5 w-36 animate-pulse rounded bg-gray-200" />
        </div>
        {/* Số khách */}
        <div className="flex-1">
          <div className="mb-2 h-4 w-20 animate-pulse rounded bg-gray-200" />
          <div className="h-5 w-32 animate-pulse rounded bg-gray-200" />
        </div>
        {/* Nút tìm kiếm */}
        <div>
          <div className="h-10 w-24 animate-pulse rounded-lg bg-gray-300" />
        </div>
      </div>
      {/* Để tránh layout shift, thêm padding-bottom */}
      <div className="pb-12" />
    </div>
  )
}
